import { makeApi } from "@zodios/core";
import { z } from "zod";

import { offerDtoSchema } from "@/types/backoffice/dto/bonus-offer/offer-dto";
import { siteStatusDtoSchema } from "@/types/backoffice/dto/bonus-offer/site-bonus-transfer-dto";

export const backofficeBonusOfferApi = makeApi([
  {
    method: "get",
    path: "/site/:siteId/status",
    response: siteStatusDtoSchema,
    alias: "findSiteBonusTransfer",
  },
  {
    method: "get",
    path: "/site/:siteId/offers",
    response: z.array(offerDtoSchema),
    alias: "findSiteOffersWithConditionsBySiteId",
  },
]);
